<template>
  <div>
    <v-container pa-0 fluid>
      <v-container>
        <v-layout row justify-center wrap text-xs-center>
          <v-flex xs12>
            <h1 class="navy--text desktop-h1">Manipulatives</h1>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container pt-3 pb-3 title text-xs-center v-if="expiringNotice">
        <v-layout justify-center pb-0 wrap>
          <v-flex xs12 sm6>
            <v-alert
              :value="true"
              color="accent"
              outline
            >
              You have {{ daysRemaining }} days remaining on your license.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container py-3 pb-0 title text-xs-center v-if="allExpiredNotice">
        <v-layout justify-center pb-0 wrap>
          <v-flex xs12 sm6>
            <v-alert
              :value="true"
              color="error"
              outline
            >
              Your license has expired. Easily renew your license now by clicking <a style="color: #3296f3; text-decoration: underline" href="https://www.brainingcamp.com/pricing" target="_blank">here.</a>
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-md fluid v-if="loading">
        <v-layout justify-center>
          <v-flex xs12 font-weight-bold ma-5 text-xs-center>
            <v-progress-circular color="secondary" indeterminate :size="50"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container style="max-width: 720px" pb-1 v-if="presentOffer">
        <v-layout justify-center headline font-weight-medium wrap elevation-1 py-3 ma-3>
          <v-flex xs12 sm9 pl-3 mt-2>
            <p class="subheading">Your redeemed manipulatives are activated. Try the others?</p>
            
          </v-flex>
          <v-flex xs12 sm3 text-xs-center text-sm-right>
            <v-btn
              color="accent"
              @click="redeemOffer"
              v-if="!processingRequest"
            >
              3 Months Free
            </v-btn>
            <v-progress-circular
              v-if="processingRequest"
              indeterminate
              color="secondary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container text-xs-center>
        <v-layout row wrap justify-middle align-start>
          <v-flex xs6 sm3 md2 my-1 v-for="scope in scopes" :key="scope.id">
            <ManipulativeItem :id="scope.id" :enabled="scope.enabled"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-container fluid text-xs-center pa-0 v-if="false && !isClassroom" style="background: linear-gradient(to bottom, white 50%, #EBF5FE 50%);">
        <a href="https://bit.ly/3OAMsuU" target="_blank">
          <img src="@/assets/upcoming-webinar.png" style="width: 100%; max-width: 800px; display: block; margin: auto">
        </a>
    </v-container>
    <v-container ice lighten-1 fluid>
      <v-container>
        <v-layout row justify-center wrap>
          <v-flex xs12 text-xs-center text-md-left>
            <p class="navy--text" style="font-size: 36px; font-weight: 600">
              Teaching Resources
            </p>
            <p class="navy--text my-3">
              Get Started with Brainingcamp Teaching Resources
            </p>
          </v-flex>
        </v-layout>
        <v-container>
          <v-layout text-xs-center fill-height :class="$vuetify.breakpoint.mdAndUp ? '': 'wrap'" :style="$vuetify.breakpoint.mdAndUp ? 'gap: 24px': 'gap: 0px'">
            <v-flex xs6 md3 class="resource_card">
              <div class="resource_content pa-3">
                <a href="https://www.brainingcamp.com/tasks" target="_blank">
                  <div>
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="6.30664" y="22.3438" width="12.7114" height="12.7114" rx="1.56448" stroke="#2196F3" stroke-width="2" />
                      <rect x="6.30859" y="6.30859" width="12.7114" height="12.7114" rx="1.56448" stroke="#2196F3" stroke-width="2" />
                      <path d="M12.8838 9.82812V15.6949M9.82812 12.6393H15.8172" stroke="#2196F3" stroke-width="1.56448" stroke-linecap="round" />
                      <rect x="22.5117" y="23.3262" width="12" height="12" rx="1.45139" transform="rotate(-8.84578 22.5117 23.3262)" stroke="#2196F3" stroke-width="2" />
                      <path d="M10.815 26.8354L14.9634 30.9839M10.6421 30.9839L14.877 26.749" stroke="#2196F3" stroke-width="1.56448" stroke-linecap="round" />
                      <rect x="22.9521" y="6.30859" width="12.7114" height="12.7114" rx="1.56448" stroke="#2196F3" stroke-width="2" />
                      <path d="M26.5 13H32.489" stroke="#2196F3" stroke-width="1.56" stroke-linecap="round" />
                    </svg>
                  </div>
                  <h3 class="my-1">Tasks</h3>
                  <p class="px-1">300+ high-quality K-8 Tasks, complete with Teacher Notes for easy implementation.</p>
                </a>
              </div>
            </v-flex>
            <v-flex xs6 md3 class="resource_card">
              <div class="resource_content pa-3">
                <a href="https://www.brainingcamp.com/ideas" target="_blank">
                  <div>
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.6424 11.209C25.885 11.209 30.1138 15.4367 30.1138 20.6804C30.1138 24.3702 27.9749 27.6984 24.7015 29.2444V31.5049C24.7015 32.2521 24.0958 32.8579 23.3485 32.8579H17.9362C17.189 32.8579 16.5832 32.2521 16.5832 31.5049V29.2444C13.3098 27.6984 11.171 24.3702 11.171 20.6804C11.171 18.1464 12.155 15.7668 13.9419 13.9799C15.7288 12.1931 18.1084 11.209 20.6424 11.209ZM18.3838 27.0618C18.9262 27.2519 19.2893 27.764 19.2893 28.3388V30.1518H21.9954V28.3388C21.9954 27.764 22.3586 27.252 22.901 27.0618C25.5965 26.1171 27.4077 23.5527 27.4077 20.6804C27.4077 16.95 24.3727 13.9151 20.6424 13.9151C16.912 13.9151 13.8771 16.95 13.8771 20.6804C13.8771 23.5527 15.6882 26.1171 18.3838 27.0618Z" fill="#2196F3" />
                      <path d="M20.643 8.77356C19.8957 8.77356 19.29 8.1678 19.29 7.4205V4.71439C19.29 3.96709 19.8957 3.36133 20.643 3.36133C21.3903 3.36133 21.9961 3.96709 21.9961 4.71439V7.4205C21.9961 8.1678 21.3903 8.77356 20.643 8.77356Z" fill="#2196F3" />
                      <path d="M33.9027 19.3281H36.6089C37.3561 19.3281 37.9619 19.9339 37.9619 20.6812C37.9619 21.4285 37.3561 22.0342 36.6089 22.0342H33.9027C33.1554 22.0342 32.5497 21.4285 32.5497 20.6812C32.5497 19.9339 33.1554 19.3281 33.9027 19.3281Z" fill="#2196F3" />
                      <path d="M4.67618 19.3281H7.38229C8.12959 19.3281 8.73535 19.9339 8.73535 20.6812C8.73535 21.4285 8.12959 22.0342 7.38229 22.0342H4.67618C3.92888 22.0342 3.32312 21.4285 3.32312 20.6812C3.32312 19.9339 3.92888 19.3281 4.67618 19.3281Z" fill="#2196F3" />
                      <path d="M29.2533 10.1555L31.1668 8.24203C31.6952 7.71359 32.5519 7.71359 33.0803 8.24203C33.6086 8.77047 33.6087 9.62716 33.0803 10.1555L31.1668 12.069C30.6384 12.5974 29.7817 12.5975 29.2533 12.069C28.7249 11.5406 28.7249 10.6839 29.2533 10.1555Z" fill="#2196F3" />
                      <path d="M8.20442 8.24203C8.73285 7.71359 9.58954 7.71359 10.1179 8.24203L12.0314 10.1555C12.5598 10.6839 12.5598 11.5407 12.0314 12.069C11.503 12.5974 10.6463 12.5975 10.1179 12.069L8.20442 10.1555C7.67605 9.62716 7.67605 8.77047 8.20442 8.24203Z" fill="#2196F3" />
                      <path d="M17.9369 35.293H23.3491C24.0964 35.293 24.7021 35.8987 24.7021 36.646C24.7021 37.3933 24.0964 37.9991 23.3491 37.9991H17.9369C17.1896 37.9991 16.5838 37.3933 16.5838 36.646C16.5838 35.8987 17.1896 35.293 17.9369 35.293Z" fill="#2196F3" />
                    </svg>
                  </div>
                  <h3 class="my-1">Ideas</h3>
                  <p>Short, time-saving videos that simplify teaching with manipulatives.</p>
                </a>
              </div>
            </v-flex>
            <v-flex xs6 md3 class="resource_card">
              <div class="resource_content pa-3">
                <a href="https://www.brainingcamp.com/workstations" target="_blank">
                  <div>
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M33.2793 4.46973C35.2015 4.56764 36.7304 6.15703 36.7305 8.10352V22.6592L36.7256 22.8457C36.6314 24.7061 35.1396 26.1982 33.2793 26.293L33.0918 26.2979H29.2441C29.3785 25.9182 29.4521 25.5096 29.4521 25.084V23.8721H33.0918C33.7612 23.8717 34.3044 23.3286 34.3047 22.6592V8.10352C34.3046 7.4339 33.7613 6.89098 33.0918 6.89062H7.62012C6.95031 6.89068 6.40728 7.43372 6.40723 8.10352V22.6592C6.40748 23.3288 6.95044 23.872 7.62012 23.8721H12.4717V25.084C12.4717 25.5097 12.5453 25.9182 12.6797 26.2979H7.62012L7.43262 26.293C5.5721 26.1985 4.08053 24.7063 3.98633 22.8457L3.98145 22.6592V8.10352C3.9815 6.09396 5.61056 4.4649 7.62012 4.46484H33.0918L33.2793 4.46973Z" fill="#2196F3" />
                      <circle cx="20.3561" cy="19.0197" r="4.8517" stroke="#2196F3" stroke-width="2.42585" />
                      <path d="M12.2769 29.0986C17.9299 27.3135 23.9959 27.3135 29.6489 29.0986C30.6155 29.4039 31.2729 30.3008 31.2729 31.3145V34.7871H10.6528V31.3145C10.6528 30.3008 11.3103 29.4039 12.2769 29.0986Z" stroke="#2196F3" stroke-width="2.42585" />
                    </svg>
                  </div>
                  <h3 class="my-1">Workstations</h3>
                  <p>Workstations combine digital manipulatives and tools to create impactful practice.</p>
                </a>
              </div>  
            </v-flex>
            <v-flex xs6 md3 class="resource_card">
              <div class="resource_content pa-3">
                <a href="https://www.brainingcamp.com/webinars" target="_blank">
                  <div>
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M31.2044 21.4774C30.6207 21.4774 30.1474 21.9507 30.1474 22.5344V26.7743C30.1474 27.8231 29.2935 28.677 28.2447 28.677H6.51674C5.46792 28.677 4.61407 27.8231 4.61407 26.7743V12.8214C4.61407 11.7726 5.46792 10.9188 6.51674 10.9188H19.0367C19.6205 10.9188 20.0938 10.4454 20.0938 9.86172C20.0938 9.278 19.6205 8.80469 19.0367 8.80469H6.51674C4.30166 8.80469 2.5 10.6063 2.5 12.8214V26.7743C2.5 28.9894 4.30166 30.791 6.51674 30.791H12.8084V34.1641H10.6263C10.0425 34.1641 9.56922 34.6375 9.56922 35.2212C9.56922 35.8049 10.0425 36.2782 10.6263 36.2782H24.1293C24.713 36.2782 25.1863 35.8049 25.1863 35.2212C25.1863 34.6375 24.713 34.1641 24.1293 34.1641H21.9471V30.791H28.2447C30.4598 30.791 32.2614 28.9894 32.2614 26.7743V22.5344C32.2614 21.9507 31.7881 21.4774 31.2044 21.4774ZM19.833 34.163H14.9213V30.791H19.833V34.163Z" fill="#2196F3" />
                      <path d="M22.1824 18.8598C22.1824 16.222 20.0367 14.0762 17.3988 14.0762C14.7609 14.0762 12.6151 16.222 12.6151 18.8598C12.6151 20.2258 13.1976 21.4508 14.1173 22.3234C13.3668 22.7251 12.7466 23.2583 12.352 23.8996C12.0466 24.3975 12.2028 25.0482 12.6997 25.3536C12.8723 25.4593 13.0637 25.5098 13.2517 25.5098C13.6075 25.5098 13.954 25.3313 14.1537 25.0059C14.5694 24.3271 15.7345 23.6423 17.3988 23.6423C19.0536 23.6423 20.2398 24.3494 20.6427 25.0047C20.9481 25.5016 21.5975 25.6589 22.0967 25.3524C22.5947 25.047 22.7497 24.3964 22.4443 23.8984C22.0509 23.2559 21.4308 22.7239 20.6791 22.321C21.5999 21.4508 22.1824 20.2258 22.1824 18.8598ZM14.728 18.8598C14.728 17.3882 15.926 16.1902 17.3976 16.1902C18.8692 16.1902 20.0672 17.3882 20.0672 18.8598C20.0672 20.3315 18.8692 21.5294 17.3976 21.5294C15.926 21.5294 14.728 20.3326 14.728 18.8598Z" fill="#2196F3" />
                      <path d="M29.7073 4C25.4098 4 21.9146 7.49526 21.9146 11.7927C21.9146 16.0901 25.411 19.5854 29.7073 19.5854C34.0035 19.5854 37.5 16.089 37.5 11.7927C37.5 7.49644 34.0047 4 29.7073 4ZM29.7073 17.4713C26.5761 17.4713 24.0286 14.9239 24.0286 11.7927C24.0286 8.66153 26.5761 6.11407 29.7073 6.11407C32.8384 6.11407 35.3859 8.66153 35.3859 11.7927C35.3859 14.9239 32.8384 17.4713 29.7073 17.4713Z" fill="#2196F3" />
                      <path d="M32.434 10.1426L30.2189 8.57703C29.5999 8.13778 28.7966 8.08492 28.1248 8.43257C27.4518 8.78139 27.0337 9.46847 27.0337 10.226V13.356C27.0337 14.1147 27.4518 14.8006 28.1248 15.1494C28.4184 15.301 28.7367 15.3761 29.0538 15.3761C29.4637 15.3761 29.8701 15.2516 30.2189 15.005L32.4328 13.4406C32.9684 13.0624 33.2878 12.4458 33.2878 11.7916C33.2878 11.1374 32.9684 10.5208 32.434 10.1426ZM29.1489 13.1728V10.4092L31.1045 11.7916L29.1489 13.1728Z" fill="#2196F3" />
                    </svg>
                  </div>
                  <h3 class="my-1">PD Webinars</h3>
                  <p>High-quality Professional Development from leading math experts.</p>
                </a>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog v-model="showFeaturePreview" width="1280">
      <v-layout wrap white>
        <v-flex xs12 v-if="showFeaturePreview">
          <video controls style="width:100%; display:block" src="https://media.brainingcamp.com/v/848323422.mp4"></video>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import manips from '@/data/manips.js'
import _ from 'lodash'
import LicensingService from '@/services/LicensingService'
import ManipulativeItem from '@/components/ManipulativeListItem'

export default {
  data: function () {
    return {
      showWebinar: true,
      loading: null,
      processingRequest: null,
      licenses: [],
      hasBundle: false,
      scopes: [],
      expiringNotice: false,
      daysRemaining: null,
      allExpiredNotice: false,
      presentOffer: false,
      showFeaturePreview: false,
      showShareDialog: false
    }
  },
  components: {
    ManipulativeItem
  },
  mounted: async function () {
    this.loading = true
    try {
      const result = await LicensingService.get()

      const unsortedLicenseList = result.data

      // sort by createdBy date before setting to vue
      this.licenses = _.reverse(_.sortBy(unsortedLicenseList, 'createdAt'))
    } catch (err) {
      if (err.response.status === 403) {
        this.$router.push({
          path: '/logout'
        }).catch(err => {})
      }
    }
    this.loading = false
  },
  computed: {
    isClassroom: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.type === 'classroom';
      }
      return false;
    }
  },
  methods: {
    redeemOffer: async function() {
      this.processingRequest = true
      try {
        const result = await LicensingService.requestKitUpgrade()

        if (result) {
          this.refreshLicenses()
        }
      } catch (err) {
        // console.log(err.response.data.error)
      }
      this.processingRequest = false
    },
    refreshLicenses: async function() {
      try {
        const result = await LicensingService.get()

        const unsortedLicenseList = result.data

        // sort by createdBy date before setting to vue
        this.licenses = _.reverse(_.sortBy(unsortedLicenseList, 'createdAt'))
      } catch (err) {
        if (err.response.status === 403) {
          this.$router.push({
            path: '/logout'
          })
        }
      }
    }
  },
  watch: {
    licenses: function() {
      var greatestExpirationDate = null
      var hasValidBundleScope = false
      let hasLessonAccess = false
      let hasUpgrade = false
      let bundleScopeFound = false
      let hasCovidGrant = false
      var vendor = undefined
      var scopes = []
      var now = new Date()
      var noticeDate = new Date(); 
      noticeDate.setDate(noticeDate.getDate() + 45);
      
      this.licenses.forEach(license => {
        var expDate = new Date(license.expiration.slice(0, 10))

        
        if (greatestExpirationDate === null || expDate > greatestExpirationDate) {
          greatestExpirationDate = expDate
        }
        if (license.scope === "*") {
          bundleScopeFound = true
        }
        
        if (expDate > now) {
          if (license.scope === "*") {
            hasValidBundleScope = true
          } else {
            scopes.push(license.scope)
          }

          if (license.grantsLessonAccess) {
            hasLessonAccess = true
          }

          if (license.source === 'KIT_TRIAL') {
            hasUpgrade = true
          }

          if (license.source === 'CLOSURES2020SCHOOL' || license.source === 'CLOSURES2020PARENT' || license.source === 'CLOSURES2020CLASS') {
            hasCovidGrant = true
          }
        }

        if (vendor === undefined) {
          vendor = license.vendor
        }
      })

      vendor = vendor === undefined ? null : vendor

      // set the state for vendor
      this.$store.dispatch('setVendor', vendor)
      
      // present expiring notice
      if (greatestExpirationDate < noticeDate) {
        this.expiringNotice = true
        this.daysRemaining = Math.ceil(Math.abs((greatestExpirationDate.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)))

        if (scopes.length === 0 && !hasValidBundleScope) {
          this.allExpiredNotice = true
          this.expiringNotice = false
        }
      } else {
        this.expiringNotice = false
        this.allExpiredNotice = false
      }

      if (hasCovidGrant) {
        this.expiringNotice = false
      }
      
      // determine if the hand2mind offer should display
      if (this.$store.getters.vendor === 'hand2mind' && !hasUpgrade && !bundleScopeFound && scopes.length >= 0) {
        this.presentOffer = true
      } else {
        this.presentOffer = false
      }

      if (this.$store.getters.user.type === 'classroom') {
        this.presentOffer = false
        this.allExpiredNotice = false
        this.expiringNotice = false
        this.daysRemaining = 100
      }

      // set the state for lesson access
      this.$store.dispatch('setLessonAccess', hasLessonAccess)
      
      // prepare ui
      this.hasBundle = hasValidBundleScope
      
      this.scopes = manips.map(item => {
        
        if (_.includes(scopes, item.id) || this.hasBundle) {
          return {id: item.id, enabled: true}
        }

        return {id: item.id, enabled: false}
      })
    }
  }
}
</script>

<style scoped>
.webinar-card {
  width: 280px;
  background: white;
  border: 2px solid #D7EBFF;
  border-radius: 18px;
  padding: 24px;
}

.resource_card {
  color: #072846;
  border-radius: 12px;
  height: 100%;
}

.resource_card :hover {
  color: #072846;
  border-radius: 12px;
  outline: 2px #3296F3 solid;
}

.resource_content {
  color: #072846;
  outline: none;
}

.resource_content :hover {
  color: #072846;
  outline: none;
}

.resource_card a {
  color: #072846;
  text-decoration: none;
}

.resource_card a {
  color: #072846;
  text-decoration: none;
}

.max_w {
  max-width: 1200px;
}


.codeInput >>> input {
  text-transform: uppercase;
}
.decoration_container {
  position: relative;
}

.decoration_container .decoration {
  position: absolute;
}
</style>
